import React from 'react';
import { useTranslation } from 'react-i18next';
import { Backdrop, Paper, IconButton, Typography } from '@mui/material';

/* Типы подсказок для программы лояльности */
export enum TooltipType {
  QR_NOT_RECOGNIZED = 'QR_NOT_RECOGNIZED',
  CODE_INCORRECT = 'CODE_INCORRECT',
  BONUS_APPLY_ERROR = 'BONUS_APPLY_ERROR',
  RECEIPT_ERROR = 'RECEIPT_ERROR',
  NO_ACTIVE_RECEIPT = 'NO_ACTIVE_RECEIPT',
  BONUS_APPLY_SUCCESS = 'BONUS_APPLY_SUCCESS',
  BONUS_APPLY_TECH_WORK = 'BONUS_APPLY_TECH_WORK',
  CLIENT_ADDED = 'CLIENT_ADDED',
  CODE_EXPIRED = 'CODE_EXPIRED',
  RECEIPT_SELECTED = 'RECEIPT_SELECTED',
  FORBIDDEN = 'FORBIDDEN',
}

interface TooltipPopupProps {
  type: TooltipType | null;
  onClose: () => void;
  bonusesToSpend?: number;
  bonusesToAdd?: number;
  position?: {
    top?: number;
    left?: number;
    bottom?: number;
    right?: number;
  };
}

const TooltipPopup: React.FC<TooltipPopupProps> = ({
  type,
  onClose,
  bonusesToSpend,
  bonusesToAdd,
  position,
}) => {
  const { t } = useTranslation();

  if (!type) return null;

  const text = t(`LoyaltyPage.Tooltip.${type}`, {
    bonusesToSpend: bonusesToSpend || 0,
    bonusesToAdd: bonusesToAdd || 0,
  });

  return (
    <>
      {/* Затемнённый фон */}
      <Backdrop open sx={{ zIndex: 999 }} onClick={onClose} />

      {/* Облако подсказки */}
      <Paper
        elevation={8}
        sx={{
          position: 'fixed',
          top: position?.top ? `${position.top}%` : undefined,
          right: position?.right ? `${position.right}%` : undefined,
          bottom: position?.bottom ? `${position.bottom}%` : undefined,
          left: position?.left ? `${position.left}%` : undefined,
          zIndex: 1000,
          p: '24px 32px',
          maxWidth: 500,
          width: '100%',
          borderRadius: 4,
          /* Хвостик облака */
          '&::before': {
            content: '""',
            position: 'absolute',
            bottom: -10,
            left: 50,
            width: 0,
            height: 0,
            borderLeft: '15px solid transparent',
            borderRight: '15px solid transparent',
            borderTop: '15px solid #fff',
            filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.1))',
          },
          /* Адаптив */
          '@media (max-width: 550px)': {
            maxWidth: '90%',
            p: '20px 24px',
          },
        }}
      >
        {/* Кнопка закрытия */}
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            fontSize: 28,
            color: 'text.secondary',
          }}
        >
          ×
        </IconButton>

        {/* Текст подсказки */}
        <Typography
          sx={{ fontSize: 16, lineHeight: 1.6, whiteSpace: 'pre-line' }}
        >
          {text}
        </Typography>
      </Paper>
    </>
  );
};

export default TooltipPopup;
